<h4><ng-content /></h4>
<span
    *ngIf="badge"
    class="badge"
>{{badge}}</span>